package com.patronat.top.ui.organisms

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.molecules.filters.AppFilterDropdown
import com.patronat.top.ui.molecules.filters.FilterOption
import com.patronat.top.ui.molecules.inputs.SearchInput
import com.patronat.top.ui.theme.AppIcons

@Composable
fun UsersControlPanel(
    searchQuery: String,
    onSearchQueryChange: (String) -> Unit,
    searchPlaceholder: String,

    filterLabel: String,
    filterOptions: List<FilterOption>,
    selectedFilterOptions: List<FilterOption>,
    onFilterChange: (List<FilterOption>) -> Unit,

    // Second filter (optional)
    filterLabel2: String? = null,
    filterOptions2: List<FilterOption>? = null,
    selectedFilterOptions2: List<FilterOption>? = null,
    onFilterChange2: ((List<FilterOption>) -> Unit)? = null,

    onAddClick: () -> Unit,
    addButtonText: String,
    isAddButtonVisible: Boolean = true,
    modifier: Modifier = Modifier
) {
    val controlHeight = 48.dp

    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start
    ) {
        SearchInput(
            query = searchQuery,
            onQueryChange = onSearchQueryChange,
            placeholder = searchPlaceholder,
            modifier = Modifier
                .weight(1f)
                .height(controlHeight)
        )

        Spacer(modifier = Modifier.width(24.dp))

        Row(
            modifier = Modifier
                .wrapContentWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.End,
        ) {
            AppFilterDropdown(
                label = filterLabel,
                options = filterOptions,
                selectedOptions = selectedFilterOptions,
                onOptionSelected = onFilterChange,
                modifier = Modifier.height(controlHeight)
            )

            if (filterLabel2 != null && filterOptions2 != null && selectedFilterOptions2 != null && onFilterChange2 != null) {
                Spacer(modifier = Modifier.width(16.dp))
                AppFilterDropdown(
                    label = filterLabel2,
                    options = filterOptions2,
                    selectedOptions = selectedFilterOptions2,
                    onOptionSelected = onFilterChange2,
                    modifier = Modifier.height(controlHeight)
                )
            }

            if (isAddButtonVisible) {
                Spacer(modifier = Modifier.width(16.dp))
                AppButton(
                    text = addButtonText,
                    onClick = onAddClick,
                    type = ButtonType.BrownFilled,
                    leadingIcon = AppIcons.Plus,
                    modifier = Modifier
                        .height(controlHeight)
                        .widthIn(min = 188.dp)
                )
            }
        }
    }
}
